import React from "react";
import { motion } from "framer-motion";
import { STEPS, IMAGES } from "../../data";

export const Manifesto = () => {
  return (
    <section id="how-it-works" data-testid="process-section" className="relative bg-[#133955] text-white py-16 md:py-24 overflow-hidden grain scroll-mt-24">
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.10] bg-cover bg-center"
        style={{ backgroundImage: `url(${IMAGES.blueprint})` }}
      />
      <div className="pointer-events-none absolute inset-0 bg-[#133955]/60" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-12 md:mb-16">
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.5 }}
            className="text-xs uppercase tracking-[0.24em] font-bold text-[#54BCE6] mb-4"
          >
            How it works
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.6 }}
            className="font-display font-extrabold tracking-tighter text-4xl md:text-5xl lg:text-6xl leading-[0.98]"
          >
            From Project Idea to Contractor Connection.
          </motion.h2>
        </div>

        <div className="rounded-3xl overflow-hidden border border-white/10">
          <div className="grid md:grid-cols-3 gap-px bg-white/10">
            {STEPS.map((step, i) => (
              <motion.div
                key={step.num}
                initial={{ opacity: 0, y: 26 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1], delay: i * 0.1 }}
                data-testid={`process-step-${step.num}`}
                className="group relative bg-[#133955] p-9 md:p-11 hover:bg-[#16405f] transition-colors duration-300"
              >
                <span className="font-display block text-6xl md:text-7xl font-extrabold text-white/10 mb-6 transition-colors duration-300 group-hover:text-[#54BCE6]/30">
                  {step.num}
                </span>
                <h3 className="font-display text-2xl md:text-[1.6rem] font-bold tracking-tight mb-3">
                  {step.title}
                </h3>
                <p className="text-white/70 leading-relaxed text-[15px]">{step.body}</p>
                <span className="absolute left-0 top-0 h-full w-[3px] bg-[#54BCE6] scale-y-0 origin-top transition-transform duration-500 group-hover:scale-y-100" />
              </motion.div>
            ))}
          </div>
        </div>

        <div className="mt-12">
          <a
            href="#request"
            data-testid="process-cta"
            className="inline-flex items-center rounded-full bg-[#54BCE6] text-[#133955] px-8 py-4 font-bold hover:bg-white transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#133955]"
          >
            Start My Project Request
          </a>
        </div>
      </div>
    </section>
  );
};
